import { CustomerModel, } from '../models'

const customer_model = new CustomerModel()

export interface User {
  customer_code: string;
  email: string;
  displayName: string;
  pictureUrl?: string;
  customer_line_id?: string;
  customer_tier_balance: number;
  point_expire_customers?: {};
  customer_tier_type?: { customer_tier_type_color: '' };
  customer_tiers?: [];
  customer_tier_lists?: { customer_tier_list_price: 0 };
}

export interface Line {
  customer_code: string;
  customer_line_id?: string;
  picture?: string;
  name?: string;
}

export const MAIN_PAGE = 'km_main_page';
export const AUTH_TOKEN_KEY = 'km_auth_token';
export const USER_DATA_KEY = 'km_user_data';
export const LINE_DATA_KEY = 'km_line_data';

export const setMainPage = (main: string): void => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(MAIN_PAGE, main);
  }
};

export const getMainPage = (): string | null => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem(MAIN_PAGE);
  }
  return null;
};

export const setAuthToken = (token: string): void => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
  }
};

export const getAuthToken = (): string | null => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem(AUTH_TOKEN_KEY);
  }
  return null;
};

export const removeAuthToken = (): void => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(USER_DATA_KEY);
  }
};

export const setUserData = (user: User): void => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(USER_DATA_KEY, JSON.stringify(user));
  }
};

export const getUserData = (): User | null => {
  if (typeof window !== 'undefined') {
    const data = localStorage.getItem(USER_DATA_KEY);
    if (data) {
      try {
        return JSON.parse(data);
      } catch (error) {
        console.error('Failed to parse user data:', error);
        return null;
      }
    }
  }
  return null;
};

export const setLineData = (user: Line): void => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(LINE_DATA_KEY, JSON.stringify(user));
  }
};

export const getLineData = (): Line | null => {
  if (typeof window !== 'undefined') {
    const data = localStorage.getItem(LINE_DATA_KEY);
    if (data) {
      try {
        return JSON.parse(data);
      } catch (error) {
        console.error('Failed to parse user data:', error);
        return null;
      }
    }
  }
  return null;
};

export const isAuthenticated = (): boolean => {
  return !!getAuthToken();
};

export const loginWithEmail = async (customer_username: string, customer_password: string): Promise<{ success: boolean; user?: User; error?: string }> => {
  const res_login = await customer_model.checkLogin({ customer_username, customer_password, })
  
  if (res_login.require === false) {
    return { success: false, error: 'ไม่สามารถล็อคอินได้ คำขอเกิดข้อผิดพลาด' };
  } else if (res_login.data.length === 0) {
    return { success: false, error: 'ไม่สามารถล็อคอินได้ โปรดตรวจสอบชื่อผู้ใช้และรหัสผ่านของคุณ' };
  } else {
    try {
      localStorage.setItem('x-access-token', res_login.x_access_token)
      localStorage.setItem('session-user', JSON.stringify(res_login.data[0]))
      // token['x-access-token'] = res_login.x_access_token
      // Generate mock token

      setAuthToken(res_login.x_access_token);
      setUserData(res_login.data[0]);
      setLineData({
        customer_code: res_login.data[0].customer_code,
        customer_line_id: '',
        picture: '',
        name: '',
      });

      return { success: true, user: res_login.data[0] };
    } catch (e) {
      return { success: false, error: 'อีเมลหรือรหัสผ่านไม่ถูกต้อง' }
    }
  }
};

export const loginWithLine = async (customer_line_id: string): Promise<{ success: boolean; user?: User; error?: string }> => {
  const res_login = await customer_model.checkLogin({ customer_line_id, })
  console.log('loginWithLine',res_login);
  
  if (res_login.require === false) {
    return { success: false, error: 'ไม่สามารถล็อคอินได้ คำขอเกิดข้อผิดพลาด' };
  } else if (res_login.data.length === 0) {
    return { success: false, error: 'ไม่สามารถล็อคอินได้ โปรดตรวจสอบชื่อผู้ใช้และรหัสผ่านของคุณ' };
  } else {
    try {
      if (typeof window !== 'undefined') {
        localStorage.setItem('x-access-token', res_login.x_access_token)
        localStorage.setItem('session-user', JSON.stringify(res_login.data[0]))
        setAuthToken(res_login.x_access_token);
        setUserData(res_login.data[0]);
      }
      return { success: true, user: res_login.data[0] };
    } catch (e) {
      return { success: false, error: 'อีเมลหรือรหัสผ่านไม่ถูกต้อง' }
    }
  }
};

export const logout = (): void => {
  removeAuthToken();
  
  // Logout from LIFF if available
  if (typeof window !== 'undefined' && (window as any).liff) {
    try {
      if ((window as any).liff.isLoggedIn()) {
        (window as any).liff.logout();
      }
    } catch (error) {
      console.error('LIFF logout failed:', error);
    }
  }
};